<div class="select-none truncate">
  <span>{{ column.topLabel | capitalize }}</span>

  <span class="ml-2 font-semibold" *ngIf="column.groupLabel"
    >{{ column.groupLabel | capitalize }} -
    {{ column.label | capitalize }}</span
  >

  <span class="ml-2 font-semibold" *ngIf="!column.groupLabel">{{
    column.label | capitalize
  }}</span>
</div>
